<template>
    <v-text-field class="common-password login-autofill-field"
                  v-bind="$attrs"
                  :type="showPassword ? 'text' : 'password'"
                  :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  autocomplete="current-password"
                  @click:append-inner="togglePasswordVisibility">
    </v-text-field>
</template>

<script>
    export default {
        name: 'common-password',
        inheritAttrs: false,
        data() {
            return {
                showPassword: false,
            };
        },
        methods: {
            togglePasswordVisibility() {
                this.showPassword = !this.showPassword;
            },
        },
    }
</script>
